import Images from "../../../utility/imagePaths";
import { TechAdvantageSectionType } from "../../../utility/types/generaTypes";
import Button from "../../common/buttons/button/Button";
import "./TechAdvantageSection.css";

type TechAdvantageSectionProps = {
  TechAdvantageData: TechAdvantageSectionType;
  style?: any;
};

const TechAdvantageSection = ({
  TechAdvantageData,
  style,
}: TechAdvantageSectionProps) => {
  return (
    <section style={style}>
      <div className="techAdvantage_section">
        <div className="techAdvantage_left_container">
          <h1 className="section_title" style={{ textAlign: "left" }}>
            {TechAdvantageData.title}
          </h1>
          <p
            className="section_description"
            style={{ width: "100%", textAlign: "left" }}
          >
            {TechAdvantageData.description}
          </p>
          <div className="techAdvantage_bottom_container">
            {TechAdvantageData.data.map((item, index) => (
              <div
                key={"advantages_points_container" + index}
                className="advantages_points_container"
              >
                <img src={Images.SVG_TICK_ICON} alt="tick" />
                <p key={index}>{item}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="techAdvantage_right_container">
          <h3>Quick Start</h3>
          <div className="techAdvantage_right_subContainer">
            {TechAdvantageData.quickStart.map((item, index) => (
              <p key={"quickStart" + index}>{item}</p>
            ))}
          </div>
          <Button
            title="View Documentation"
            path={TechAdvantageData.viewDocPath}
            pathType="_blank"
            backgroundColor="linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
            className="viewDocumentation_btn display_none_mobile"
            leftComponent={
              <img
                src={Images.SVG_VIEW_DOC_ICON}
                alt="View Documentation"
                className="viewDocIcon"
              />
            }
          />
        </div>
      </div>
    </section>
  );
};

export default TechAdvantageSection;
